import React from "react";

import NonAiMedCodes from "./nonAiMedCodes";
import AiMedCodes from "./aiMedCodes";

const MedCodes = ({
  details,
  readOnly,
  medCodes,
  suggDiag,
  loading,
  medCodeError,
  suggProce,
}) => {
  console.log("details: ", details);

  if (details?.ai_coding_recommendation === "No") {
    return (
      <NonAiMedCodes
        medCodes={medCodes}
        suggDiag={suggDiag}
        details={details}
        readOnly={readOnly}
        loading={loading}
        medCodeError={medCodeError}
        suggProce={suggProce}
      />
    );
  } else {
    return <AiMedCodes details={details} readOnly={readOnly} />;
  }
};

export default MedCodes;
